export default __webpack_public_path__ + "img/f405a3f57b634bbe68cf683ccc70e1d6.svg";